export const defaultCopyLinkText = 'copy link';
export const clickedCopyLinkText = 'copied!';
export const CLOUD9_DOCUMENT_WRITEBACK_BETA_ORG_IDS = [
  131,
  2391,
  2315,
  2369,
  2518,
];
